module.exports = __webpack_public_path__ + "img/titles4.1b627dbf.png";